import React from "react";
import { websiteBaseUrl } from "../../libraries/helper";

export default (props) => {
  return <iframe className="iframeReport" src={`${websiteBaseUrl}/sales-report`} />;
};
